export const ACTIVATE_WEB_TO_PRINT_MODE = 'ACTIVATE_WEB_TO_PRINT_MODE'

export function activateWebToPrintMode() {
  return {
    type: ACTIVATE_WEB_TO_PRINT_MODE
  }
}

export const END_WEB_TO_PRINT_MODE = 'END_WEB_TO_PRINT_MODE'

export function endWebToPrintMode() {
  return {
    type: END_WEB_TO_PRINT_MODE
  }
}

export const TOGGLE_CONTENT_FOR_PRINT = 'TOGGLE_CONTENT_FOR_PRINT'

export function toggleContentForPrint(contentType, contentItem) {
  return {
    type: TOGGLE_CONTENT_FOR_PRINT,
    contentType,
    contentItem
  }
}

export const MARK_CONTENT_LOADED = 'MARK_CONTENT_LOADED'

export function markContentLoaded(contentType, itemSlug) {
  return {
    type: MARK_CONTENT_LOADED,
    contentType,
    itemSlug
  }
}



// WEBPACK FOOTER //
// ./src/actions/webToPrint.js